import apiClient from "@/clients/apiClient";
import { ApiResponse } from "@/utils/ApiResponse";
import { CategoriaFindOneInterface } from "../../interfaces/categoriaInterfaces/CategoriaFindOne.interface ";

export async function FinOneCategoriaProductoAction (
    categoriaId: string
): Promise<ApiResponse<CategoriaFindOneInterface>> {
   const {data} = await apiClient.get(`gpCategoriasProducto/${categoriaId}`);
    return {
        status: 200,
        data,
        message: "Categoría de producto obtenida correctamente",
    };
}